import Request from "../lib/request";
import {
  ACCOUNTING_SOFTWARES_API,
  FORM_SETTINGS_API,
  FORM_VALIDATION_SETTINGS_API,
  PROJECTS_API,
  SOFTWARE_SETTINGS_API,
  UPDATE_TRANSACTION_DAY_LIMIT
} from "../constants/api";
import { PROJECT_ID } from "../constants/storageKeys";

const baseUrl = process.env.REACT_APP_API_URL;

export const getSoftwareSetting = () => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${SOFTWARE_SETTINGS_API}`,
    needToken: true
  });
};

export const softwareSettingStore = data => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${SOFTWARE_SETTINGS_API}`,
    needToken: true,
    data: data
  });
};

export const transactionFormSettingStore = data => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${FORM_SETTINGS_API}`,
    needToken: true,
    data: data
  });
};

export const paymentValidationSettingStore = data => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${FORM_VALIDATION_SETTINGS_API}`,
    needToken: true,
    data: data
  });
};

export const getSoftwareList = () => {
  return Request({
    method: "get",
    url: `${baseUrl}/${ACCOUNTING_SOFTWARES_API}`,
    needToken: true
  });
};

export const getSubSoftwareList = softwareId => {
  return Request({
    method: "get",
    url: `${baseUrl}/${ACCOUNTING_SOFTWARES_API}/${softwareId}`,
    needToken: true
  });
};

export const sharedContacts = () => {
  const projectId = localStorage.getItem("project_id");
  return Request({
    method: "get",
    url: `${baseUrl}/projects/${projectId}/sharedContacts?paginate=false`,
    needToken: true
  });
};
export const setUserState = (userId, action) => {
  const projectId = localStorage.getItem("project_id");
  return Request({
    method: "put",
    url: `${baseUrl}/projects/${projectId}/users/${userId}/states`,
    needToken: true,
    data: action
  });
};

export const showUser = userId => {
  const projectId = localStorage.getItem("project_id");
  return Request({
    method: "get",
    url: `${baseUrl}/projects/${projectId}/users/${userId}`,
    needToken: true
  });
};

export const updateUser = (userId, data) => {
  const projectId = localStorage.getItem("project_id");
  return Request({
    method: "put",
    url: `${baseUrl}/projects/${projectId}/users/${userId}/settings`,
    needToken: true,
    data: data
  });
};
